import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
} from "@angular/fire/firestore";
import { Observable } from "rxjs";

interface TileSet {
  name_de: string;
  name_en: string;
  icon_url: string;
  image_url: string;
  download_url: string;
  images: string[];
}

@Injectable({
  providedIn: "root",
})
export class FirestoreService {
  mvTileCollection: AngularFirestoreCollection<TileSet>;
  mvTiles: Observable<TileSet[]>;

  constructor(public firestore: AngularFirestore) {}

  tile_collection: AngularFirestoreCollection<String[]>;
  tiles: Observable<String[]>;

  getMvTiles() {
    return this.firestore.collection("mv-tiles").valueChanges();
  }

  getGameData(id: string) {
    return this.firestore.doc("games/" + id).valueChanges();
  }

  getFreeTiles() {
    return this.firestore.collection("engine-free").valueChanges();
  }

  getAppData(id: string) {
    return this.firestore.doc("apps/" + id).valueChanges();
  }
}
